import styled, {css} from 'styled-components';
import colors from '../../styles/colors';

export const StyledInputBtn = styled.input`
    border-radius: 25px;
    padding 1.1rem 2.0rem;
    text-decoration: none;
    color: white;
    margin: 0.1rem 0.5rem;
    background-color: ${colors.secondary};
    font-size: 1.0rem;
    border: none;
    transition: 0.5s;

    :focus{
        outline-width: 0;
    }

    ${props => props.primary && css`
        color: black;
        background-color: white;
    `}

    ${props => props.submit && css`
        :hover{
            color: black;
            background-color: white;
        }
    `}
`
